var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowStepToTheEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8C1.5 7.72386 1.72386 7.5 2 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H2C1.72386 8.5 1.5 8.27614 1.5 8Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64645 3.14645C6.84171 2.95118 7.15829 2.95118 7.35355 3.14645L11.8536 7.64645C12.0488 7.84171 12.0488 8.15829 11.8536 8.35355L7.35355 12.8536C7.15829 13.0488 6.84171 13.0488 6.64645 12.8536C6.45118 12.6583 6.45118 12.3417 6.64645 12.1464L10.7929 8L6.64645 3.85355C6.45118 3.65829 6.45118 3.34171 6.64645 3.14645Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2C13.7761 2 14 2.22386 14 2.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V2.5C13 2.22386 13.2239 2 13.5 2Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStepToTheEnd);
export default __webpack_public_path__ + "static/media/arrow-step-to-the-end.58f747cec676f8265d9dd0221fb567b5.svg";
export { ForwardRef as ReactComponent };